import Base from './Base';
import Tag from '../models/Tag';

export default class Tags extends Base {
    get models() {
        const collection = this.data.map(item => new Tag(item));
        collection.collection = this;

        return collection;
    }
}
